import axios from "axios";
import { attachAuth } from "services/authAxios";

// ─────────────────────────────────────────────────────────────────────────────
// Cliente de la API de calidad-ia (config seccionada de Ollama/geo/webhook +
// los dos system prompts).
//
// Instancia axios PROPIA — NO se reusa la de beartrack (config/axios-config)
// porque el baseURL es OTRO: calidad-ia se sirve directo desde su URL pública,
// no por el proxy server-side de beartrack. Comparte, eso sí, el MISMO JWT de
// beartrack en localStorage: calidad-ia valida HS256 y exige role.type === admin.
//
// El default hornea la URL pública para que la vista funcione aunque
// REACT_APP_CALIDAD_IA_API no esté seteada en el build (CRA hornea las env en
// build; el dev server no relee .env sin reiniciar el servicio).
// ─────────────────────────────────────────────────────────────────────────────

const BASE_URL =
  process.env.REACT_APP_CALIDAD_IA_API || "https://calidad-api.beartrackapp.com/v1";

const CalidadIaAxios = axios.create({
  baseURL: BASE_URL,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Adjunta el Bearer con un access vigente (renueva antes de mandar si hace falta)
// y reintenta una vez ante 401. Ver services/authAxios.
attachAuth(CalidadIaAxios);

// A propósito NO se replica el interceptor de respuesta 401→logout→/login de
// config/axios-config: un 401/403 de calidad-ia NO debe cerrar la sesión de
// beartrack ni sacar al usuario a /login. Los errores se manejan en la vista
// (toast + estado inline).

const CONFIG = "config";
const PROMPT = "prompt";

export const calidadIaConfigService = {
  // ── General (compartido) — solo lectura: modelo/VRAM, workers y colas. ──
  getSystem: () => CalidadIaAxios.get("system").then((r) => r.data),

  // ── Calidad (evaluación QA) ──
  // Config: un solo GET trae ollama/geo/webhook + defaults/bounds/updated_at.
  getConfig: () => CalidadIaAxios.get(CONFIG).then((r) => r.data),
  // PUT parcial POR SECCIÓN: patch = { ollama:{…} } | { geo:{…} } | { webhook:{…} }.
  // Responde el config completo actualizado.
  putConfig: (patch) => CalidadIaAxios.put(CONFIG, patch).then((r) => r.data),
  // Prompts de análisis: kind = "system" | "simplified".
  getPrompt: (kind) => CalidadIaAxios.get(PROMPT, { params: { kind } }).then((r) => r.data),
  putPrompt: (kind, text) => CalidadIaAxios.put(PROMPT, { kind, text }).then((r) => r.data),

  // ── Helpdesk (chat) ──
  // GET trae { system_prompt, model:{free,portal}, ollama:{keep_alive, preload_on_startup} }.
  getHelpdesk: () => CalidadIaAxios.get("helpdesk/config").then((r) => r.data),
  putHelpdeskPrompt: (content) =>
    CalidadIaAxios.put("helpdesk/system-prompt", { content }).then((r) => r.data),
  // profile = "free" | "portal".
  putHelpdeskModel: (profile, body) =>
    CalidadIaAxios.put(`helpdesk/model/${profile}`, body).then((r) => r.data),
  putHelpdeskOllama: (body) => CalidadIaAxios.put("helpdesk/ollama", body).then((r) => r.data),
  // Nota: el S3 se movió a su propio servicio (src/services/s3AdminService.js),
  // directo a s3-api.beartrackapp.com/panel/* — ya NO pasa por calidad-ia.
};

export default calidadIaConfigService;
